import { Vue } from 'vue-property-decorator';
import { CancelToken } from '@/app/shared/utils';
export { CancelToken } from '@/app/shared/utils';

// TODO: REVIEW, remove explicit any
export interface IncludeComponentsHandlerInterface {
  includeComponents($parsedContent: any, cancel: CancelToken): Promise<Vue[]>;
}

export const IncludeComponentsHandlerSymbol = Symbol.for('IncludeComponentsHandlerInterface');
